module.exports = __webpack_public_path__ + "static/media/charticon.c74d8456.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/charticon.svg
// module id = 1720
// module chunks = 0